// extracted by mini-css-extract-plugin
export default {"ticketStatusContainer":"styles_ticketStatusContainer__pWh5B"};